import { logger } from '@townsquare/logging/logger';

import ActivityProvider from './activity-provider';

const getActivityProvider = () => {
	try {
		return new ActivityProvider();
	} catch (e) {
		logger.warning(`Failed to initialize ActivityProvider`, {
			cause: e,
		});
		return undefined;
	}
};

export const resolvedActivityProvider: ActivityProvider | undefined = getActivityProvider();
